module.exports = __webpack_public_path__ + "assets/img/role-e552e63e.png";